import { useMemo } from 'react';
import { PAYMENT_FREQUENCY_OPTIONS } from '../constants';

const useSchedule = (paymentFrequency, paymentFrequencies) => useMemo(() => {
  if (paymentFrequency === null) {
    return null;
  }

  const groupedPayments = {};
  // eslint-disable-next-line consistent-return
  Object.values(paymentFrequencies).forEach((scheduleData) => {
    const schedules = scheduleData[PAYMENT_FREQUENCY_OPTIONS[paymentFrequency]];

    if (!schedules) return [];

    schedules.forEach(({ beforeDate, amount }) => {
      if (groupedPayments[beforeDate]) {
        groupedPayments[beforeDate] += Math.floor(amount);
      } else {
        groupedPayments[beforeDate] = Math.floor(amount);
      }
    });
  });

  return Object.entries(groupedPayments).map(([beforeDate, amount]) => ({
    beforeDate,
    amount,
  }));
}, [paymentFrequencies, paymentFrequency]);

export default useSchedule;
